<template>
  <div class="flex-grow-1">
    <SideBarSearch
      v-if="showSearchPanel"
      class="search-panel"
      :class="showFullSearch ? 'full-search-panel' : ''"
      :show-full-search="showFullSearch"
      @updatePanelSize="updatePanelSize"
    />
    <div
      v-if="showFullSearch"
      class="expansion-icon"
      :class="showSearchPanel ? 'icon-to-right' : ''"
      @click="showSearchPanel = !showSearchPanel"
    >
      <v-icon v-if="showSearchPanel">
        mdi-chevron-left
      </v-icon>
      <v-icon v-else>
        mdi-chevron-right
      </v-icon>
    </div>

    <GoogleMap :class="showSearchPanel && showFullSearch ? 'google-map-with-panel' : ''" />
  </div>
</template>

<script>
import GoogleMap from '@/components/GoogleMap';
import SideBarSearch from '@/components/SideBarSearch.vue';

export default {
  name: 'HomePage',

  components: {
    GoogleMap,
    SideBarSearch
  },

  data: () => ({
    showSearchPanel: true,
    showFullSearch: false
  }),

  methods: {
    updatePanelSize(fullPanel) {
      this.showFullSearch = fullPanel;
    }
  }
};
</script>

<style lang="scss" scoped>
.expansion-icon {
  position: absolute;
  z-index: 1;
  padding: 12px 5px;
  margin-top: 64px;
  cursor: pointer;
  background-color: var(--base-surface-colour);
}

.search-panel {
  position: absolute;
  z-index: 1;
  width: 500px;
  background-color: var(--base-surface-colour);
  box-shadow: 10px 10px 20px -10px var(--misc-shadow-colour);

  &.full-search-panel {
    height: calc(100% - 64px);
  }
}

.google-map-with-panel {
  width: calc(100% - 500px);
  margin-left: 500px;
}

.icon-to-right {
  margin-left: 500px;
}
</style>
